import { TLegalDocument, TLegalDocumentAcceptanceStatus, TLegalDocumentType } from '@/types/Legal.types';
import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';

export const privacyPolicyGet = async (): Promise<TLegalDocument> => {
  const type: TLegalDocumentType = 'PRIVACY_POLICY';
  const { data } = await api.get<TCustomAxiosResponse<TLegalDocument>>(apiPaths.legal.activeByType(type));

  const document = data.data;
  return document;
};

export const termsAndConditionsGet = async () => {
  const type: TLegalDocumentType = 'TERMS_AND_CONDITIONS';
  const { data } = await api.get<TCustomAxiosResponse<TLegalDocument>>(apiPaths.legal.activeByType(type));

  const document = data.data;
  return document;
};

export const contentPolicyGet = async () => {
  const type: TLegalDocumentType = 'CONTENT_POLICY';
  const { data } = await api.get<TCustomAxiosResponse<TLegalDocument>>(apiPaths.legal.activeByType(type));

  const document = data.data;
  return document;
};

export const acceptedDocumentsGet = async (): Promise<TLegalDocumentAcceptanceStatus[]> => {
  const { data } = await api.get<
    TCustomAxiosResponse<{ userId: string; status: Record<string, TLegalDocumentAcceptanceStatus> }>
  >(apiPaths.legal.acceptanceStatus);
  const statuses = data.data.status;
  const documents = Object.values(statuses);

  return documents;
};

export const acceptEulaDocumentPost = async (documentId: string): Promise<{ success: boolean }> => {
  const { data } = await api.post<TCustomAxiosResponse<{ success: boolean }>>(apiPaths.legal.acceptById(documentId));
  return data.data;
};
